import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'lib-pass-val-lib',
  template: `
  <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.3.1/dist/css/bootstrap.min.css" integrity="sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T" crossorigin="anonymous">
  <div class="container p-5 m-5 text-center bg-warning">
    <h3>Password Validator</h3>
    <input [(ngModel)]="password" #ctrl="ngModel" type="password" required>

    <p>Value: {{ password }}</p>

    <button (click)="validate()">Validate</button>
    <br>
    <span>{{validationStatus}}</span>
</div>
  `,
  styles: []
})
export class PassValLibComponent implements OnInit {
  @Input() minLength:number;
  @Input() maxLength:number;
  password:string='';
  validationStatus:string;
  constructor() { }

  ngOnInit(): void {
  }
  validate() {
    if(this.password.length>=this.minLength && this.password.length<=this.maxLength){
      this.validationStatus="Valid Password"
    }
    else if(this.password.length==0){
      this.validationStatus="Password is mandatory and cannot be left bank"
    }
    else if(this.password.length<=this.minLength){
      this.validationStatus="Password length is less than the specified minimum length."
    }
    else if(this.password.length>=this.maxLength){
      this.validationStatus="Password length is greater than the specified length."
    }
    setTimeout(()=>{
      this.validationStatus="";
      this.password="";
    },1000)
  }
}